import { memo } from 'react';
import { useTheme } from '@mui/material';
import QualificationSurveyValidationIllustrationLight from './qualificationSurveyValidation.svg?react';
import QualificationSurveyValidationIllustrationDark from './qualificationSurveyValidation_dark.svg?react';

export const QualificationSurveyValidationIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return (
        <QualificationSurveyValidationIllustrationDark
          aria-hidden="true"
          {...props}
        />
      );
    return (
      <QualificationSurveyValidationIllustrationLight
        aria-hidden="true"
        {...props}
      />
    );
  },
);
